export enum CommentStatus {
  UnderConstruction = 'under-construction',
  Groom = 'groom',
  Todo = 'todo',
  InProgress = 'in-progress',
  PendingReview = 'pending-review',
  Completed = 'completed',
  Closed = 'closed',
}
